<template>
<div class="main_box"
v-loading.fullscreen.lock="$store.state.fullscreenLoading"
element-loading-background="rgba(255,255,255,1)"
:element-loading-text="$store.state.loadingTxt"
>

<v-header
ref="headerChild"
:topMenu="$store.state.account.topMenu"
:userInfo="$store.state.account.userInfo"
:topMenuIndex="$store.state.account.topMenuIndex"
></v-header>

<v-left
:leftMenu="$store.state.account.leftMenu"
:leftMenuIndex="$store.state.account.leftMenuIndex"
@setLeftMenuIndex="setLeftMenuIndex"
v-show="isChildComponents"></v-left>
  <div class="right_main">
      <!-- 已打开面板 -->
      <v-tabs :isAddTab="isAddTab"></v-tabs>
      <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
  <v-footer></v-footer>
</div>
</template>

<script>
import vLeft from './components/leftMenu'
import vHeader from './components/header'
import vFooter from './components/footer.vue'
import vTabs from './components/tabs.vue'

import account from 'api/account.js';
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    vHeader,  vLeft,  vTabs,  vFooter
  },
  data(){
    return{
      loading:true,
      isAddTab:true,
      isChildComponents:false,
      allMenu:[],//所有菜单
      leftMenu:[],//左侧菜单
    }
  },
  created(){
    this.getMenuIndex();
    this.open();
     //清空部分初始数据
    this.clearCache();
  },
  computed:{
    ...mapState("account",['userInfo',"userMenuList"])
  },
  watch:{
    "$route.path":{
      handler:function(to, from){
        this.open();
        this.getMenuIndex();

        //清空部分初始数据
        this.clearCache();
      },
      // 深度观察监听
      deep: true
    }
  },
 /* updated: function () {
    this.$nextTick(function () {
    })
  }, */
  methods:{
    ...mapActions('pages',["open"]),
    ...mapActions('account', [
      "logout",
      "getAccountInfo",
      "topMenuTab",
      "setLeftMenu"
    ]),
    ...mapActions('cache',['clearCache']),   
    //验证当前按钮
    checkAuth(){
      let isMenu = this.userMenuList.findIndex(v=>v.resourceCode == this.$route.name);
      //console.log(isMenu,'==== 当前有没有这个权限=== =');
     if(isMenu === -1 && this.$route.name != 'home'){//没有权限
        this.open(true);
        //this.$router.push({'name':"no-auth-user"});
      }else{
        this.open(false);
      }
    },

    //获取菜单索引
    getMenuIndex(){
      /* if(this.$route.name == 'no-auth-user'){
        $('.main_left').width(0);
        $('.right_main').css('left',0);
      } */

      let obj = this.userMenuList.find(v=>v.resourceCode == this.$route.name);
      if(obj){
        if(obj.parentResourceId != 0){
          this.getMenuParent(obj.parentResourceId);
        }else{
          this.$store.state.account.topMenuIndex = obj.resourceId;
        }
      }else{
        this.$store.state.account.topMenuIndex = 0;
      }
      //设置左侧菜单
      this.setLeftMenu({"topIndex":this.$store.state.account.topMenuIndex,"routeName":this.$route.name});

      this.$store.state.fullscreenLoading = false;
      this.isChildComponents = true;
    },
    //设置左侧菜单索引
    setLeftMenuIndex(index){
      this.$store.state.account.leftMenuIndex = index;
    },
    //已选-找父级
    getMenuParent(pid){
      let obj = this.userMenuList.find(v=>v.resourceId === pid);
      if(obj){
        if(obj.parentResourceId != 0){
          this.getMenuParent(obj.parentResourceId);
        }else{
          this.$store.state.account.topMenuIndex = obj.resourceId;
        }
      }
    },
    //找左侧菜单的索引
    getLeftMenuParent(pid){
      let obj = this.userMenuList.find(v=>v.resourceId === pid);
      if(obj.level > 2){
        this.getLeftMenuParent(obj.parentResourceId);
      }else if(obj.level == 2){
        this.$store.state.account.leftMenuIndex = obj.resourceId;
      }
    }
  }
}
</script>

<style>
</style>
